/**
 * История версий пакета (ТЗ FR-31).
 *
 * Документы доступны только через приложение (решение заказчика 25.10.2026:
 * у хранилища приложения на Диске нет страницы в интерфейсе портала, ссылку
 * на папку дать нельзя). Файлы лежат в папке дела, версия определяется по имени
 * файла (правило именования FR-30). Отдельного хранилища версий нет —
 * это сознательное решение: одна копия документов, а не две.
 */

import { useEffect, useState } from 'react';
import { api, packageArchiveName } from '../../api.js';

export function VersionList({
  caseId,
  folderId,
  reloadKey,
}: {
  caseId: string;
  folderId?: string;
  /** Меняется после формирования пакета: список перечитывается */
  reloadKey?: number;
}) {
  const [versions, setVersions] = useState<Array<{ version: number; files: Array<{ id: string; name: string; createTime?: string }> }>>([]);
  const [error, setError] = useState<string | null>(null);
  const [zipError, setZipError] = useState<string | null>(null);
  useEffect(() => {
    api
      .versions(caseId, folderId)
      .then((r) => setVersions(r.versions))
      .catch((e) => setError((e as Error).message));
  }, [caseId, folderId, reloadKey]);

  if (error) return <p className="warning">История версий недоступна: {error}</p>;
  if (versions.length === 0) return <p className="hint">Пакет ещё не формировался.</p>;

  return (
    <>
    {zipError && <p className="warning">{zipError}</p>}
    <ul className="versions">
      {versions.map((version) => (
        <li key={version.version}>
          <strong>Версия {version.version}</strong>
          {version.files.length > 1 && (
            <button
              type="button"
              className="link-button"
              onClick={() =>
                void api
                  .downloadZip(caseId, version.files.map((f) => f.id), packageArchiveName(version.files.map((f) => f.name), version.version))
                  .catch((e) => setZipError((e as Error).message))
              }
            >
              {' '}скачать все архивом
            </button>
          )}
          <ul>
            {version.files.map((file) => (
              <li key={file.id}>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => void api.downloadFile(caseId, file.id, file.name)}
                >
                  {file.name}
                </button>
                {file.createTime && <span className="hint"> · {new Date(file.createTime).toLocaleString('ru-RU')}</span>}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
    </>
  );
}
